export const CART_ITEM_ADDED = "CART_ITEM_ADDED";
export const CART_ITEMS_ADDED = "CART_ITEMS_ADDED";
export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";

export const PRODUCTS_VIEW_TYPE = {
  LIST: "list",
  ICON: "icon",
};

export const IDLE = "IDLE";
export const LOADING = "LOADING";
export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";

export const defaultApiStatuses = ["IDLE", "LOADING", "SUCCESS", "ERROR"];

export const apiStatus = {
  IDLE,
  LOADING,
  SUCCESS,
  ERROR,
};
